











import Vue from "vue"
import {CsvImportResponse, CsvImportResponseEntity, CsvStatus} from "@/model/dto/csv-upload.ts"
import {FieldDescriptor, FieldTypeEnum} from "@/model/entity/field-descriptor"
import {DatatableEntity} from "@/model/entity/datatable-entity"
import {CollectionRequest} from "@/model/entity/collection-request/collection-request.ts"
import {classToPlain, plainToClass} from "class-transformer"
import Upload, {IUpload} from "@/components/upload/Upload.vue"
import {collectionRequestService} from "@/model/service/collection-request/collection-request-service.ts"
import {PickupData} from "@/model/entity/collection-request/pickup-data"
import {ColReqAddress} from "@/model/entity/collection-request/col-req-address"
import {ShipmentParcelShop} from "@/model/entity/shipment/shipment-parcel-shop"
import { countryList, countryService, ICountryService } from "@/model/service/country/country-service"
import {Country} from "@/model/entity/country/country"
import moment from "moment"

class CollectionRequestCsvDto extends DatatableEntity implements CsvImportResponseEntity {
  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.collection_request.upload.pickup_address.name",
    isFilterable: true
  })
  pickupAddressName: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.collection_request.upload.pickup_address.name2",
    isFilterable: true
  })
  pickupAddressName2: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.collection_request.upload.pickup_address.country"
  })
  pickupAddressCountryisoCodeAlpha2: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.collection_request.upload.pickup_address.zip_code",
    columnWidth: "55"
  })
  pickupAddressZipCode: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.collection_request.upload.pickup_address.city",
    columnWidth: "55"
  })
  pickupAddressCity: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.collection_request.upload.pickup_address.street",
    columnWidth: "55"
  })
  pickupAddressStreet: string


  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.collection_request.upload.pickup_address.house_number",
    columnWidth: "55"
  })
  pickupAddressHouseNumber: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.collection_request.upload.pickup_address.tel",
    columnWidth: "55"
  })
  pickupAddressTel: string

  @FieldDescriptor({
      fieldType: FieldTypeEnum.TEXT,
      fieldPrettyName: "entity.collection_request.upload.pickup_address.email",
      columnWidth: "55"
  })
  pickupAddressEmail: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.collection_request.upload.pickup_address.depot",
    columnWidth: "60"
  })
  pickupAddressDepot: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.collection_request.upload.delivery_address.name",
    isFilterable: true
  })
  deliveryAddressName: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.collection_request.upload.delivery_address.name2",
    isFilterable: true
  })
  deliveryAddressName2: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.collection_request.upload.delivery_address.country"
  })
  deliveryAddressCountryisoCodeAlpha2: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.collection_request.upload.delivery_address.zip_code",
    columnWidth: "55"
  })
  deliveryAddressZipCode: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.collection_request.upload.delivery_address.city",
    columnWidth: "55"
  })
  deliveryAddressCity: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.collection_request.upload.delivery_address.street",
    columnWidth: "55"
  })
  deliveryAddressStreet: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.collection_request.upload.delivery_address.house_number",
    columnWidth: "55"
  })
  deliveryAddressHouseNumber: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.collection_request.upload.delivery_address.tel",
    columnWidth: "55"
  })
  deliveryAddressTel: string
    @FieldDescriptor({
        fieldType: FieldTypeEnum.TEXT,
        fieldPrettyName: "entity.collection_request.upload.delivery_address.email",
        columnWidth: "55"
    })
    deliveryAddressEmail: string
  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.collection_request.upload.delivery_address.depot",
    columnWidth: "60"
  })
  deliveryAddressDepot: string
  @FieldDescriptor({
    fieldType: FieldTypeEnum.NUMBER,
    fieldPrettyName: "entity.collection_request.upload.pickup_data.number_of_parcels",
    columnWidth: "55"
  })
  pickupDataNumberOfParcels: string
  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.collection_request.upload.pickup_data.info1",
    columnWidth: "55"
  })
  pickupDataInfo1: string
  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.collection_request.upload.pickup_data.info2",
    columnWidth: "55"
  })
  pickupDataInfo2: string
  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.collection_request.upload.pickup_data.weight",
    columnWidth: "55"
  })
  pickupDataWeight: string
  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.collection_request.upload.pickup_data.date",
    columnWidth: "55"
  })
  pickupDataDate: string
  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.collection_request.service_code",
    columnWidth: "55"
  })
  serviceCode: string
  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.collection_request.pudo_id",
    columnWidth: "55"
  })
  shipmentParcelShopPudoId: string
  @FieldDescriptor({
    fieldType: FieldTypeEnum.DATE,
    fieldPrettyName: "entity.collection_request.entry_date",
    columnWidth: "55"
  })
  entryDate: Date

  csvStatus: CsvStatus

  statusDescription: string

  constructor(
    pickupAddressName: string,
    pickupAddressName2: string,
    pickupAddressCountryisoCodeAlpha2: string,
    pickupAddressZipCode: string,
    pickupAddressCity: string,
    pickupAddressStreet: string,
    pickupAddressHouseNumber: string,
    pickupAddressTel: string,
    pickupAddressEmail: string,
    pickupAddressDepot: string,
    deliveryAddressName: string,
    deliveryAddressName2: string,
    deliveryAddressCountryisoCodeAlpha2: string,
    deliveryAddressZipCode: string,
    deliveryAddressCity: string,
    deliveryAddressStreet: string,
    deliveryAddressHouseNumber: string,
    deliveryAddressTel: string,
    deliveryAddressEmail: string,
    deliveryAddressDepot: string,
    pickupDataNumberOfParcels: string,
    pickupDataInfo1: string,
    pickupDataInfo2: string,
    serviceCode: string,
    shipmentParcelShopPudoId: string,
    entryDate: Date,
    csvStatus: CsvStatus,
    statusDescription: string
  ) {
    super()
    this.pickupAddressName = pickupAddressName
    this.pickupAddressName2 = pickupAddressName2
    this.pickupAddressCountryisoCodeAlpha2 = pickupAddressCountryisoCodeAlpha2
    this.pickupAddressZipCode = pickupAddressZipCode
    this.pickupAddressCity = pickupAddressCity
    this.pickupAddressStreet = pickupAddressStreet
    this.pickupAddressHouseNumber = pickupAddressHouseNumber
    this.pickupAddressTel = pickupAddressTel
    this.pickupAddressEmail = pickupAddressEmail
    this.pickupAddressDepot = pickupAddressDepot
    this.deliveryAddressName = deliveryAddressName
    this.deliveryAddressName2 = deliveryAddressName2
    this.deliveryAddressCountryisoCodeAlpha2 = deliveryAddressCountryisoCodeAlpha2
    this.deliveryAddressZipCode = deliveryAddressZipCode
    this.deliveryAddressCity = deliveryAddressCity
    this.deliveryAddressStreet = deliveryAddressStreet
    this.deliveryAddressHouseNumber = deliveryAddressHouseNumber
    this.deliveryAddressTel = deliveryAddressTel
    this.deliveryAddressEmail = deliveryAddressEmail
    this.deliveryAddressDepot = deliveryAddressDepot
    this.pickupDataNumberOfParcels = pickupDataNumberOfParcels
    this.pickupDataInfo1 = pickupDataInfo1
    this.pickupDataInfo2 = pickupDataInfo2
    this.serviceCode = serviceCode
    this.shipmentParcelShopPudoId = shipmentParcelShopPudoId
    this.entryDate = entryDate
    this.csvStatus = csvStatus
    this.statusDescription = statusDescription
  }

  trimQuotes(input: string): string {
      if (exists(input)) {
          return input.replace(/['"]+/g, "")
      } else {
          return ""
      }
  }

  processFields() {
     this.pickupAddressName = this.trimQuotes(this.pickupAddressName)
     this.pickupAddressCountryisoCodeAlpha2 = this.trimQuotes(this.pickupAddressCountryisoCodeAlpha2)
     this.pickupAddressZipCode = this.trimQuotes(this.pickupAddressZipCode)
     this.pickupAddressCity = this.trimQuotes(this.pickupAddressCity)
     this.pickupAddressStreet = this.trimQuotes(this.pickupAddressStreet)
     this.pickupAddressHouseNumber = this.trimQuotes(this.pickupAddressHouseNumber)
     this.pickupAddressTel = this.trimQuotes(this.pickupAddressTel)
     this.pickupAddressEmail = this.trimQuotes(this.pickupAddressEmail)
     this.pickupAddressDepot = this.trimQuotes(this.pickupAddressDepot)
     this.deliveryAddressName = this.trimQuotes(this.deliveryAddressName)
     this.deliveryAddressCountryisoCodeAlpha2 = this.trimQuotes(this.deliveryAddressCountryisoCodeAlpha2)
     this.deliveryAddressZipCode = this.trimQuotes(this.deliveryAddressZipCode)
     this.deliveryAddressCity = this.trimQuotes(this.deliveryAddressCity)
     this.deliveryAddressStreet = this.trimQuotes(this.deliveryAddressStreet)
     this.deliveryAddressHouseNumber = this.trimQuotes(this.deliveryAddressHouseNumber)
     this.deliveryAddressTel = this.trimQuotes(this.deliveryAddressTel)
     this.deliveryAddressEmail = this.trimQuotes(this.deliveryAddressEmail)
     this.deliveryAddressDepot = this.trimQuotes(this.deliveryAddressDepot)
     this.pickupDataNumberOfParcels = this.trimQuotes(this.pickupDataNumberOfParcels)
     this.pickupDataInfo1 = this.trimQuotes(this.pickupDataInfo1)
     this.pickupDataInfo2 = this.trimQuotes(this.pickupDataInfo2)
     this.serviceCode = this.trimQuotes(this.serviceCode)
     this.shipmentParcelShopPudoId = this.trimQuotes(this.shipmentParcelShopPudoId)
     this.statusDescription = this.trimQuotes(this.statusDescription)

  }

}

export default Vue.extend({
    components: {Upload},
    data() {
        return {
            fields: CollectionRequestCsvDto.getFieldDescriptionList(),
            collectionRequestService: collectionRequestService,
            countryService: countryService,
            countryList: countryList
    }
  },
  methods: {
    back() {
      this.$router.push("/language_editor")
    },
    toCollectionRequest(inputCollectionRequestCsvDto: CollectionRequestCsvDto): CollectionRequest[] {
        const collectionRequestCsvDto = plainToClass(CollectionRequestCsvDto, inputCollectionRequestCsvDto)
        collectionRequestCsvDto.processFields()
        const result = []
        const weights = collectionRequestCsvDto.pickupDataWeight.split(",")
        const momentVariable = moment(collectionRequestCsvDto.pickupDataDate, "YYYYMMDD")
        const pickupCountry = this.countryList.find(
          country => country.isoCodeAlpha2 === collectionRequestCsvDto.pickupAddressCountryisoCodeAlpha2
        )!

        const deliveryCountry = this.countryList.find(
          country => country.isoCodeAlpha2 === collectionRequestCsvDto.deliveryAddressCountryisoCodeAlpha2
        )!

        const numberOfParcels = +collectionRequestCsvDto.pickupDataNumberOfParcels

        for (let counter: number = 0; counter < numberOfParcels; counter++) {
            const pickupAddress = new ColReqAddress(
              collectionRequestCsvDto.pickupAddressName,
              collectionRequestCsvDto.pickupAddressName2,
              pickupCountry,
              collectionRequestCsvDto.pickupAddressZipCode,
              collectionRequestCsvDto.pickupAddressCity,
              collectionRequestCsvDto.pickupAddressStreet,
              collectionRequestCsvDto.pickupAddressHouseNumber,
              collectionRequestCsvDto.pickupAddressTel,
              collectionRequestCsvDto.pickupAddressEmail,
              collectionRequestCsvDto.pickupAddressDepot
            )

            const deliveryAddress = new ColReqAddress(
              collectionRequestCsvDto.deliveryAddressName,
              collectionRequestCsvDto.deliveryAddressName2,
              deliveryCountry,
              collectionRequestCsvDto.deliveryAddressZipCode,
              collectionRequestCsvDto.deliveryAddressCity,
              collectionRequestCsvDto.deliveryAddressStreet,
              collectionRequestCsvDto.deliveryAddressHouseNumber,
              collectionRequestCsvDto.deliveryAddressTel,
              collectionRequestCsvDto.deliveryAddressEmail,
              collectionRequestCsvDto.deliveryAddressDepot
            )

            let resolvedWeight = 0.0
            if (counter < weights.length) {
                resolvedWeight = Number(weights[counter]) * 1000
            }

            const pickupData = new PickupData(
              1,
              momentVariable.toDate().getTime(),
              resolvedWeight,
              collectionRequestCsvDto.pickupDataInfo1,
              collectionRequestCsvDto.pickupDataInfo2
            )

            const entryDate = new Date()
            let pudoId = null
            if (exists(collectionRequestCsvDto.shipmentParcelShopPudoId)) {
                pudoId = collectionRequestCsvDto.shipmentParcelShopPudoId
            }

            const cr = new CollectionRequest(
              pickupAddress,
              deliveryAddress,
              pickupData,
              new ShipmentParcelShop(pudoId, null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null),
              collectionRequestCsvDto.serviceCode,
              entryDate
            )
            result.push(classToPlain(cr))
        }
        return result
    },
    submit(fileResponseList: CsvImportResponse<CollectionRequestCsvDto>[]) {
      const vm = this
      const csvFile = fileResponseList
      .flatMap(fileResponse => {
        return fileResponse.items
      })
      .map(collectionRequestCsvDto => {
          return classToPlain(this.toCollectionRequest(collectionRequestCsvDto))
      })
      const csvFile2 = csvFile.flat(1)
      vm.$http
        .post("/collection_request/submit_csv", csvFile2 as any)
        .then(() => {
          vm.endLoad()
          vm.$router.push("/list_collection_request")
        })
        .catch((error: any) => {
          vm.endLoad()
          vm.$notify.error({
            title: vm.$t("upload.status.error").toString(),
            message: error.message
          })
        })
    },
    uploadFile(fileData: FormData) {
      const vm = this
      const upload = vm.$refs.upload as IUpload
      vm.startLoad()
      this.$http
        .post("collection_request/file_upload", fileData)
        .then(response => {
          response.data.forEach(
            (file: any) => (file.items = file.items.map((raw: object) => plainToClass(CollectionRequest, raw)))
          )
          upload.fileResponseList.push(...response.data)

          vm.endLoad()
        })
        .catch(() => {
          vm.endLoad()
        })
    }
  }
})
